import React from 'react';
import { observer } from 'mobx-react-lite';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { debounce } from '../../../jira-common/utils/CommonUtils';
import { toSelectOption } from '../../models/SelectOption';
import { QuestionStore, toChoiceQuestionAnswerOrEmpty } from '../../stores/QuestionStore';
import { isAsyncCreatable } from '../../utils/jiraFieldUtils';
import { DisplayMode } from '../RenderForm';
import { EditDropdownMultiselect } from './edit/EditDropdownMultiselect';
import { ViewDropdownMultiselect } from './view/ViewDropdownMultiselect';
export const DropdownMultiselect = observer(({
  id,
  questionStore,
  formStore,
  displayMode
}) => {
  var _questionStore$issueF;
  const availableOptions = questionStore.availableOptions();
  const currentAnswer = toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer);
  const currentOptions = questionStore.getAnswerChoicesAsObjects();
  const hasOtherChoice = !!questionStore.otherChoiceId;
  const showEditComponent = displayMode === DisplayMode.Edit && !(getBooleanFF('platform.proforma-read-only-questions.wewrsr') && questionStore.formQuestion.readOnly) && !((_questionStore$issueF = questionStore.issueFieldData) !== null && _questionStore$issueF !== void 0 && _questionStore$issueF.readOnlyReason);
  if (showEditComponent) {
    const otherChoiceSelected = hasOtherChoice && currentOptions.some(option => option.value === questionStore.otherChoiceId);
    const onChange = values => {
      const newChoiceIds = values.map(option => option.value);
      questionStore.setAnswer({
        text: otherChoiceSelected ? toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer).text : '',
        choices: newChoiceIds,
        // ideally - make `choices` objects, not ids, and remove `choiceObjects` prop. But ... (what's the problem? - ask Jason Thai or Banu)
        choiceObjects: values.map(QuestionStore.optionToChoice)
      });
    };
    const loadChoicesAsync = questionStore.isAsyncChoicesField ? debounce((inputValue, callback) => {
      formStore.loadChoicesAsync(questionStore.id, inputValue).then(_ => callback(questionStore.choices.map(toSelectOption)));
    }, 500) : undefined;
    const onOtherChoiceTextChange = event => {
      questionStore.setAnswer({
        text: event.target.value,
        choices: toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer).choices
      });
    };
    return /*#__PURE__*/React.createElement(EditDropdownMultiselect, {
      id: id,
      key: `${id}-${questionStore.dependentFieldChangedCount}`,
      options: availableOptions,
      value: currentOptions,
      loading: questionStore.loading,
      loadOptions: loadChoicesAsync,
      isCreatable: isAsyncCreatable(questionStore),
      onChange: onChange,
      hasOtherOption: hasOtherChoice,
      otherOptionSelected: otherChoiceSelected,
      otherOptionText: currentAnswer.text,
      onOtherOptionTextChange: onOtherChoiceTextChange,
      isInvalid: !!questionStore.validationErrors
    });
  }
  return /*#__PURE__*/React.createElement(ViewDropdownMultiselect, {
    id: id,
    options: availableOptions,
    value: currentOptions,
    hasOtherOption: hasOtherChoice,
    otherOptionText: currentAnswer.text,
    displayMode: displayMode
  });
});